import Image from "next/image";

import arrowRightIcon from "assets/icons/arrow_right.svg";
import arrowLeftIcon from "assets/icons/arrow_left.svg";

import styles from "./index.module.scss";

//TODO: 型定義は後で修正
type Props = {
  data: any;
  setFilterList: any;
  setApplyFilter?: any;
  hideArrow?: boolean;
};

const TotalPagination: React.FC<Props> = ({
  data,
  setFilterList,
  setApplyFilter,
  hideArrow
}) => {
  return (
    <div className={styles.pagination}>
      {!hideArrow && data.page.prev_page_url && (
        <div
          className={styles.arrow_icon}
          onClick={() => {
            setFilterList((state: any) => ({
              ...state,
              page: data.page.current_page - 1
            }));
            if (setApplyFilter) setApplyFilter("paging");
          }}
        >
          <Image src={arrowLeftIcon} alt="前へ" />
        </div>
      )}
      {`${data.page.from}~${data.page.to}/${data.page.total} 件`}
      {!hideArrow && data.page.next_page_url && (
        <div
          className={styles.arrow_icon}
          onClick={() => {
            setFilterList((state: any) => ({
              ...state,
              page: data.page.current_page + 1
            }));
            if (setApplyFilter) setApplyFilter("paging");
          }}
        >
          <Image src={arrowRightIcon} alt="次へ" />
        </div>
      )}
    </div>
  );
};

export default TotalPagination;
